export class ApiError extends Error {
  constructor(
    public status: number,
    public statusText: string,
    public body: unknown,
  ) {
    super(`${status} ${statusText}`);
    this.name = "ApiError";
  }
}

type RequestOptions = Omit<RequestInit, "body"> & {
  body?: unknown;
  params?: Record<string, string>;
};

let baseUrl = "";

export function setBaseUrl(url: string) {
  baseUrl = url.replace(/\/$/, "");
}

export function getBaseUrl(): string {
  return baseUrl;
}

export async function apiClient<T>(
  endpoint: string,
  { body, params, headers, ...init }: RequestOptions = {},
): Promise<T> {
  const url = new URL(endpoint, baseUrl || undefined);

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
  }

  const isNativeBody =
    body instanceof FormData || body instanceof URLSearchParams;

  const response = await fetch(url, {
    ...init,
    headers: {
      ...(isNativeBody ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
    body: isNativeBody ? body : body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => null);
    throw new ApiError(response.status, response.statusText, errorBody);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}
